import PropTypes from "prop-types";
import { createField } from "./utils";

const Customer = {
    ssn: createField(PropTypes.string, ""),
    firstName: createField(PropTypes.string, ""),
    middleName: createField(PropTypes.string, ""),
    lastName: createField(PropTypes.string, ""),
    address: createField(PropTypes.string, ""),
    country: createField(
        PropTypes.shape({
            code: PropTypes.string,
            name: PropTypes.string,
        }),
        null
    ),
    city: createField(PropTypes.string, ""),
    state: createField(PropTypes.string, ""),
    zipCode: createField(PropTypes.string, ""),
    birthDate: createField(PropTypes.instanceOf(Date), null),
    birthPlace: createField(PropTypes.string, ""),
    homePhone: createField(PropTypes.string, ""),
    workPhone: createField(PropTypes.string, ""),
    notes: createField(PropTypes.string, ""),
    email: createField(PropTypes.string, ""),
    referredBy: createField(PropTypes.string, ""),
    photo: createField(PropTypes.object, null),
    enabled: createField(PropTypes.bool, true),
};

export default Customer;
